import React from 'react';


import { Modal, Spin, Table } from 'antd';
import Title from 'antd/es/typography/Title';
import * as _ from 'lodash';
import { formatPoint } from 'app/shared/util/percent';

type IOtherPointEvaluationProps = {
    isOpen: boolean;
    onClose: () => void;
    data: any;
    isLoading: boolean;
};

export const OtherPointsEvaluationComponent = ({ isOpen, onClose, data, isLoading }: IOtherPointEvaluationProps) => {
    const columns = [
        {
            title: <span className='fw-bold'>Người ý kiến</span>,
            key: 'userName',
            width: 250,
            render: item => item?.performerName ? `${item?.workflowLevelName} - ${item?.performerName}` : item?.workflowLevelName
        },
        {
            title: <span className='fw-bold'>Điểm đánh giá</span>,
            key: 'score',
            width: 250,
            dataIndex: 'score',
            render: item => item && `${formatPoint(item)}%`,
        },
    ]
    return (
        <Modal open={isOpen} maskClosable={false} footer={null} onCancel={onClose} width={'50vw'} className='view'>
            <div className="d-flex gap-5">
                <Title level={3}>Điểm đánh giá</Title>
            </div>
            <Table columns={columns} pagination={false} loading={isLoading} dataSource={data.map(feedback => ({
                key: feedback.versionName,
                workflowLevelName: feedback.versionName,
                children: feedback?.evaluateScoreOfLevels?.map(item => ({
                    ...item,
                    key: item.performerName,
                })),
            }))}
            />
        </Modal>
    );
};

export default OtherPointsEvaluationComponent;
